import { Level2OuterPageLoading } from "@octopusdeploy/design-system-components";
import { links } from "@octopusdeploy/portal-routes";
import { repository } from "~/clientInstance";
import { AsyncInternalRedirect } from "~/routing/AsyncInternalRedirect";
export function ScopedUserRoleToTeamRedirect({ scopedUserRoleId }: {
    scopedUserRoleId: string;
}) {
    return (<AsyncInternalRedirect loader={async () => {
            const scopedUserRole = await repository.ScopedUserRoles.get(scopedUserRoleId);
            return links.teamPage.generateUrl({ teamId: scopedUserRole.TeamId });
        }} renderWhenLoading={<Level2OuterPageLoading />}/>);
}
